export default __webpack_public_path__ + "static/form-27f1c8501060a06e74ef3715162d4ba8.png";